<template>
  <div>
    <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
      <div class="d-flex align-items-center p-0">
        <h2 class="text-left mb-0">
          {{ editor.name }}
        </h2>
        <svg
          @click="openEditNameModal"
          class="ml-3 cursor-pointer"
          :title="$t('dvir.templateName')"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
            fill="#2CCE89" />
        </svg>
      </div>
    </div>
    <div class="data-table team-data-table bg-white rounded table-custom-border">
      <div class="bg-white pt-3 pt-sm-4 rounded px-0 pb-0">
        <div class="px-3 mb-3 d-flex justify-content-between align-items-center flex-wrap">
          <p class="f-12 text-grey mb-0 text-left">{{ $t("dvir.itemsHint") }}</p>
          <div class="d-flex align-items-center">
            <p class="f-12 text-grey mb-0 mr-3">
              {{ $t("dvir.itemCount", { count: editor.items.length }) }}
            </p>
            <b-button
              variant="primary"
              class="mx-0 h-40px px-3 d-flex align-items-center f-14"
              @click="openAddItemModal"
            >
              <b-icon icon="plus" class="p-0 mr-2" aria-hidden="true"></b-icon>
              {{ $t("dvir.addItem") }}
            </b-button>
          </div>
        </div>
        <b-table
          ref="sortableTable"
          class="dvir-items-table"
          responsive
          primary-key="id"
          :fields="itemFields"
          :items="editor.items"
          show-empty
          :empty-text="$t('dvir.noItems')"
        >
          <template #head(sort)="">
            <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
              <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
              <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
            </svg>
          </template>
          <template #cell(sort)="">
            <svg class="sortable-handle" :title="$t('dvir.dragToReorder')" width="4" height="18" viewBox="0 0 4 18"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
              <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
              <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
            </svg>
          </template>
          <template #cell(name)="data">
            <b-form-input
              v-model="data.item.name"
              :placeholder="$t('dvir.itemTitle')"
              class="unit"
            ></b-form-input>
          </template>
          <template #cell(description)="data">
            <textarea
              v-autogrow
              v-model="data.item.description"
              class="form-control f-12"
              :placeholder="$t('dvir.itemDescription')"
              rows="1"
            ></textarea>
          </template>
          <template #cell(card_type)="data">
            <b-form-select class="f-12" v-model="data.item.card_type" :options="cardTypeOptions"></b-form-select>
          </template>
          <template #cell(action)="data">
            <svg @click="removeItem(data.item.id)" class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </template>
        </b-table>
      </div>
    </div>
    <div class="setting-card mt-3">
      <h4 class="mb-0 pl-0">{{ $t("dvir.signatureRequirements") }}</h4>
      <div class="chk-row">
        <b-form-checkbox v-model="editor.sig_driver" class="text-left pl-0">
          <span class="chk-label">{{ $t("dvir.driverSignature") }}</span>
          <span class="chk-sub">{{ $t("dvir.driverSignatureHint") }}</span>
        </b-form-checkbox>
      </div>
      <div class="chk-row">
        <b-form-checkbox v-model="editor.sig_mechanic" class="text-left pl-0">
          <span class="chk-label">{{ $t("dvir.mechanicSignature") }}</span>
          <span class="chk-sub">{{ $t("dvir.mechanicSignatureHint") }}</span>
        </b-form-checkbox>
      </div>
    </div>
    <div class="setting-card mt-3">
      <h4 class="mb-0 pl-0">{{ $t("dvir.assignedTo") }}</h4>
      <div class="chk-row" v-for="mode in assignModes" :key="mode.value">
        <b-form-radio v-model="editor.assign_mode" :value="mode.value" name="assign-mode" class="text-left">
          <span class="chk-label">{{ mode.label }}</span>
          <span class="chk-sub">{{ mode.hint }}</span>
        </b-form-radio>
      </div>
      <div v-if="editor.assign_mode === 'tags'" class="text-left select_arrow pl-0">
        <label class="state">{{ $t("dvir.selectTags") }}</label>
        <v-select
          append-to-body
          multiple
          class="bg_white w-100 f-12"
          v-model="editor.assigned_tags"
          :options="allTags"
          item-value="id"
          item-text="label"
          :reduce="(option) => option.id"
        ></v-select>
      </div>
      <div v-if="editor.assign_mode === 'units'" class="text-left pl-0">
        <label class="state d-block">{{ $t("dvir.selectUnits") }}</label>
        <b-button
          variant="outline-primary"
          class="mx-0 h-40px px-3 d-flex align-items-center f-14"
          @click="openUnitModal"
        >
          {{ $t("dvir.selectUnits") }}
        </b-button>
        <div class="selected-units-preview" v-if="selectedUnitChips.length">
          <span class="unit-chip" v-for="unit in selectedUnitChips" :key="unit.id">
            {{ unit.label }}
          </span>
        </div>
        <p class="f-12 text-grey mb-0 mt-2">
          {{ $t("dvir.unitsCount", { count: editor.assigned_units.length }) }}
        </p>
      </div>
      <div class="d-flex justify-content-end align-items-center flex-wrap mt-4 p-0">
        <b-button
          variant="secondary"
          class="mx-0 h-40px w-100px mr-2 d-flex justify-content-center align-items-center f-14"
          @click="$emit('close')"
        >
          {{ $t("maintenanceShared.close") }}
        </b-button>
        <b-button
          variant="primary"
          class="export equipment d-flex justify-content-center align-items-center w-100px h-40px"
          @click="saveTemplate()"
        >
          <p class="mb-0 text-white p-0">{{ $t("dvir.save") }}</p>
        </b-button>
      </div>
    </div>
    <b-modal
      id="modal-edit-template-name"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
      :body-class="'px-3 pt-2'"
      :header-class="'align-items-center'"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("dvir.templateName") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <b-form-group :label="$t('dvir.templateName')" class="text-left mb-0">
        <b-form-input
          v-model="nameDraft"
          :placeholder="$t('dvir.templateNamePlaceholder')"
          class="unit"
        ></b-form-input>
        <p v-if="errors && errors.templateName" class="field-error">
          {{ errors.templateName[0] }}
        </p>
      </b-form-group>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
          <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary" @click="closeEditNameModal">
            {{ $t("dvir.cancel") }}
          </b-button>
          <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="saveTemplateName">
            {{ $t("dvir.save") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-add-dvir-item"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
      :body-class="'px-3 pt-2'"
      :header-class="'align-items-center'"
      scrollable
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("dvir.addItem") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <b-row>
        <b-col cols="12">
          <b-form-group :label="$t('dvir.itemTitleLabel')" class="text-left mb-0">
            <b-form-input
              v-model="newItem.name"
              :placeholder="$t('dvir.itemTitlePlaceholder')"
              class="unit"
            ></b-form-input>
            <p v-if="errors && errors.name" class="field-error">
              {{ errors.name[0] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-form-group :label="$t('dvir.description')" class="text-left mb-0">
            <b-form-textarea
              v-model="newItem.description"
              :placeholder="$t('dvir.itemDescriptionPlaceholder')"
              rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-form-group :label="$t('dvir.fieldType')" class="text-left mb-0">
            <b-form-select class="f-12" v-model="newItem.card_type" :options="cardTypeOptions"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
          <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary" @click="closeAddItemModal">
            {{ $t("dvir.cancel") }}
          </b-button>
          <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="saveNewItem">
            {{ $t("dvir.save") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-select-units"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
      :body-class="'px-3 pt-2 pb-4'"
      :header-class="'align-items-center'"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("dvir.selectUnits") }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          Close Modal
        </b-button>
      </template>
      <div class="text-left select_arrow">
        <label class="state">{{ $t("dvir.selectUnits") }}</label>
        <v-select
          multiple
          class="bg_white w-100 f-12"
          v-model="unitModalSelected"
          :options="unitOptions"
          item-value="id"
          item-text="label"
          :reduce="(option) => option.id"
          @search="searchAssets"
        >
          <template #no-options>
            {{ $t("dvir.searchUnits") }}
          </template>
        </v-select>
        <p class="f-12 text-grey mb-0 mt-2">
          {{ $t("dvir.unitsCount", { count: unitModalSelected.length }) }}
        </p>
      </div>
      <template #modal-footer>
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
          <b-button class="mx-0 h-40px w-100px m-0 mr-3" variant="secondary" @click="closeUnitModal">
            {{ $t("dvir.cancel") }}
          </b-button>
          <b-button class="mx-0 mb-0 h-40px px-3 m-0" variant="primary" @click="confirmUnitSelection">
            {{ $t("dvir.confirmSelection") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "DVIRTemplateEditor",
  components: { vSelect },
  directives: {
    // Grows a textarea with its content, never dropping below the 40px the other
    // fields in the row use.
    autogrow: {
      inserted(el) {
        const resize = () => {
          el.style.height = "auto";
          el.style.height = `${Math.max(el.scrollHeight, 40)}px`;
        };
        el.__autogrow__ = resize;
        el.addEventListener("input", resize);
        resize();
      },
      componentUpdated(el) {
        if (el.__autogrow__) el.__autogrow__();
      },
      unbind(el) {
        if (el.__autogrow__) el.removeEventListener("input", el.__autogrow__);
      },
    },
  },
  props: {
    // A starter preset (no id) or a saved template row.
    template: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: {
        id: null,
        title: "",
        name: "",
        key: "",
        description: "",
        equipment_type: "",
        items: [],
        sig_driver: true,
        sig_mechanic: false,
        assign_mode: "all-vehicles",
        assigned_units: [],
        assigned_tags: [],
      },
      unitOptions: [],
      unitModalSelected: [],
      newItem: { name: "", description: "", card_type: "pass-fail" },
      nameDraft: "",
      errors: {},
    };
  },
  computed: {
    ...mapGetters(["tags", "userCompany"]),
    allTags() {
      return this.tags.map((item) => ({ id: item.id, label: item.add_tag }));
    },
    selectedUnitChips() {
      return this.editor.assigned_units.map(
        (id) => this.unitOptions.find((unit) => unit.id === id) || { id, label: id }
      );
    },
    cardTypeOptions() {
      return [
        { value: "pass-fail", text: this.$t("dvir.ctPassFail") },
        { value: "pass-fail-photo", text: this.$t("dvir.ctPassFailPhoto") },
        { value: "photo", text: this.$t("dvir.ctPhoto") },
        { value: "note", text: this.$t("dvir.ctNote") },
      ];
    },
    assignModes() {
      return [
        { value: "all", label: this.$t("dvir.all"), hint: this.$t("dvir.allHint") },
        { value: "vehicles", label: this.$t("dvir.allVehicles"), hint: this.$t("dvir.allVehiclesHint") },
        { value: "trailers", label: this.$t("dvir.allTrailers"), hint: this.$t("dvir.allTrailersHint") },
        { value: "tags", label: this.$t("dvir.specificTags"), hint: this.$t("dvir.specificTagsHint") },
        { value: "units", label: this.$t("dvir.specificUnits"), hint: this.$t("dvir.specificUnitsHint") },
      ];
    },
    itemFields() {
      return [
        { key: "sort", label: "", thStyle: { minWidth: "20px", width: "20px" }, thClass: "font-table-weight-bold", tdClass: "align-top" },
        { key: "name", label: this.$t("dvir.itemTitle"), thClass: "font-table-weight-bold", tdClass: "align-top" },
        { key: "description", label: this.$t("dvir.description"), thStyle: { width: "40%" }, thClass: "font-table-weight-bold", tdClass: "align-top" },
        { key: "card_type", label: this.$t("dvir.fieldType"), thStyle: { width: "180px" }, thClass: "font-table-weight-bold", tdClass: "align-top" },
        { key: "action", label: this.$t("dvir.actionColumn"), thClass: "font-table-weight-bold" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "getDVIRTemplate",
      "getFilteredEquipments",
      "getAllTags",
      "setNotification",
      "setLoader",
      "addDVIRTemplate",
      "updateDVIRTemplate",
    ]),
    async fetchTemplate() {
      // A starter preset has no id — there is nothing to fetch, so edit it as-is.
      if (!this.template || !this.template.id) {
        this.loadTemplate(this.template);
        return;
      }
      try {
        this.setLoader(true);
        const data = await this.getDVIRTemplate(this.template.id);
        this.loadTemplate(data || this.template);
      } catch (error) {
        console.error("Error fetching DVIR template:", error);
        // Fall back to the row the list handed over.
        this.loadTemplate(this.template);
      } finally {
        this.setLoader(false);
      }
    },
    loadTemplate(template) {
      const assignedUnits = (template.assigned_units || []).map((id) => `${id}`);
      this.editor = {
        id: template.id || null,
        title: template.name,
        name: template.name,
        key: template.key,
        description: template.description || "",
        equipment_type: template.equipment_type,
        items: (template.definition || []).map((item) => ({
          ...item,
          card_type: item.card_type || "pass-fail",
        })),
        sig_driver: template.require_driver_signature !== false,
        sig_mechanic: template.require_mechanic_signature === true,
        assign_mode: template.applies_to || this.assignModeFor(template),
        assigned_units: assignedUnits,
        assigned_tags: (template.assigned_tags || []).map((tag) => (tag && tag.id ? tag.id : tag)),
      };
      // Seed the search options so saved units show their unit # instead of a raw id.
      this.unitOptions = (template.assigned_units_detail || []).map((unit) => ({
        id: `${unit.id}`,
        label: unit.unit_no,
        type: "equipment",
      }));
      this.$nextTick(() => this.initSortable());
    },
    // Fallback for records saved before applies_to existed.
    assignModeFor(template) {
      if ((template.assigned_units || []).length) return "units";
      if ((template.assigned_tags || []).length) return "tags";
      if (template.equipment_type === "Trailer") return "trailers";
      if (template.equipment_type === "All") return "all";
      return "vehicles";
    },
    templatePayload() {
      // applies_to is the assignment rule; the backend resolves what it covers.
      // Only the matching list is sent, so a mode switch can't leak the other one.
      const mode = this.editor.assign_mode;
      return {
        name: this.editor.name.trim(),
        description: this.editor.description || "",
        equipment_type: this.editor.equipment_type,
        applies_to: mode,
        require_driver_signature: this.editor.sig_driver,
        require_mechanic_signature: this.editor.sig_mechanic,
        assigned_units: mode === "units" ? this.editor.assigned_units : [],
        assigned_tags: mode === "tags" ? this.editor.assigned_tags : [],
        definition: this.editor.items.map((item, index) => ({
          id: item.id,
          name: item.name,
          description: item.description,
          category: item.category || "",
          card_type: item.card_type || "pass-fail",
          order: index + 1,
        })),
      };
    },
    async saveTemplate() {
      if (!this.editor.name.trim()) {
        await this.setNotification({
          msg: this.$t("dvir.templateNameRequired"),
          type: "error",
          color: "red",
        });
        return;
      }
      // The serializer drops untitled entries, so a template of blank rows saves empty.
      if (!this.editor.items.filter((item) => (item.name || "").trim()).length) {
        await this.setNotification({
          msg: this.$t("dvir.itemsRequired"),
          type: "error",
          color: "red",
        });
        return;
      }
      try {
        this.setLoader(true);
        const payload = this.templatePayload();
        if (this.editor.id) await this.updateDVIRTemplate({ id: this.editor.id, payload });
        else await this.addDVIRTemplate(payload);
        this.$emit("close");
        await this.setNotification({
          msg: this.$t("dvir.templateSaved"),
          type: "success",
          color: "green",
        });
      } catch (error) {
        await this.setNotification({ msg: this.apiError(error), type: "error", color: "red" });
      } finally {
        this.setLoader(false);
      }
    },
    apiError(error) {
      if (typeof error === "string") return error;
      if (error?.error) return error.error;
      if (error?.detail) return error.detail.error || error.detail;
      const firstField = error && Object.values(error)[0];
      if (Array.isArray(firstField)) return firstField[0];
      return firstField || this.$t("dvir.templateSaveFailed");
    },
    openUnitModal() {
      this.unitModalSelected = [...this.editor.assigned_units];
      this.$bvModal.show("modal-select-units");
    },
    closeUnitModal() {
      this.$bvModal.hide("modal-select-units");
    },
    async searchAssets(searchText) {
      if (!searchText) return;
      try {
        const equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });
        const options = (equipmentRecords || []).map((item) => ({
          id: `${item.id}`,
          label: item.unit_no,
          type: item.type,
        }));
        // Keep the options behind the current picks so their labels survive a new search.
        const selected = this.unitOptions.filter((option) => this.unitModalSelected.includes(option.id));
        this.unitOptions = [...new Map([...selected, ...options].map((item) => [item.id, item])).values()];
      } catch (error) {
        console.error("Error searching units:", error);
      }
    },
    confirmUnitSelection() {
      this.editor.assigned_units = [...this.unitModalSelected];
      this.closeUnitModal();
    },
    removeAssignedUnit(id) {
      this.editor.assigned_units = this.editor.assigned_units.filter((unitId) => unitId !== id);
    },
    openEditNameModal() {
      this.nameDraft = this.editor.name;
      this.errors = {};
      this.$bvModal.show("modal-edit-template-name");
    },
    closeEditNameModal() {
      this.$bvModal.hide("modal-edit-template-name");
    },
    async saveTemplateName() {
      const name = this.nameDraft.trim();
      if (!name) {
        this.errors = { templateName: [this.$t("dvir.templateNameRequired")] };
        return;
      }
      const previousName = this.editor.name;
      this.editor.name = name;
      this.editor.title = name;
      // A template built from a starter has no record yet — its name goes up with
      // everything else on Save.
      if (!this.editor.id) {
        this.closeEditNameModal();
        return;
      }
      try {
        this.setLoader(true);
        await this.updateDVIRTemplate({ id: this.editor.id, payload: { name } });
        this.closeEditNameModal();
        await this.setNotification({
          msg: this.$t("dvir.templateSaved"),
          type: "success",
          color: "green",
        });
      } catch (error) {
        // Names are unique per company, so a clash is a realistic failure — put
        // the old name back and keep the modal open with the reason.
        this.editor.name = previousName;
        this.editor.title = previousName;
        this.errors = { templateName: [this.apiError(error)] };
      } finally {
        this.setLoader(false);
      }
    },
    openAddItemModal() {
      this.newItem = { name: "", description: "", card_type: "pass-fail" };
      this.errors = {};
      this.$bvModal.show("modal-add-dvir-item");
    },
    closeAddItemModal() {
      this.$bvModal.hide("modal-add-dvir-item");
    },
    saveNewItem() {
      if (!this.newItem.name.trim()) {
        this.errors = { name: [this.$t("dvir.itemTitleRequired")] };
        return;
      }
      const lastOrder = this.editor.items.length
        ? Math.max(...this.editor.items.map((item) => item.order || 0))
        : 0;
      const lastId = this.editor.items.length
        ? Math.max(...this.editor.items.map((item) => item.id || 0))
        : 0;
      this.editor.items.push({
        id: lastId + 1,
        name: this.newItem.name.trim(),
        description: this.newItem.description.trim(),
        category: "",
        card_type: this.newItem.card_type,
        order: lastOrder + 1,
      });
      this.closeAddItemModal();
    },
    setAllCardType(cardType) {
      this.editor.items.forEach((item) => {
        item.card_type = cardType;
      });
    },
    removeItem(id) {
      this.editor.items = this.editor.items.filter((item) => item.id !== id);
    },
    initSortable() {
      if (!this.$refs.sortableTable || !window.Sortable) return;
      const tableBody = this.$refs.sortableTable.$el.querySelector('tbody');
      window.Sortable.create(tableBody, {
        animation: 150,
        handle: '.sortable-handle',
        onEnd: (evt) => {
          const { oldIndex, newIndex, from, item } = evt;
          if (oldIndex === newIndex) return;
          // Sortable moved the real <tr>, but Vue owns this DOM. Put the row back
          // where it came from, then reorder the data — Vue renders the new order.
          if (newIndex > oldIndex) from.insertBefore(item, from.children[oldIndex]);
          else from.insertBefore(item, from.children[oldIndex + 1] || null);
          const items = [...this.editor.items];
          const [moved] = items.splice(oldIndex, 1);
          items.splice(newIndex, 0, moved);
          this.editor.items = items.map((entry, index) => ({ ...entry, order: index + 1 }));
        },
      });
    },
  },
  created() {
    this.fetchTemplate();
    this.getAllTags(this.userCompany);
  },
};
</script>
<style scoped>
/* ── EDITOR SETTINGS ── */
.setting-card {
  height: 100%;
  padding: 1rem;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 0.25rem;
}
.setting-card h4 {
  margin-bottom: 1rem;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #6c757d;
}
.chk-row {
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}
.chk-row:last-child {
  padding-bottom: 0;
  border-bottom: none;
}
.chk-label {
  display: block;
  font-size: 13px;
  color: #212529;
}
.chk-sub {
  display: block;
  margin-top: 1px;
  font-size: 11px;
  color: #6c757d;
}

/* ── UNIT PICKER ── */
.selected-units-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;
}
.unit-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: rgba(45, 105, 246, 0.1);
  border: 1px solid rgba(45, 105, 246, 0.5);
  color: #2d69f6;
  font-size: 11px;
  font-weight: 500;
}

/* ── ITEMS TABLE ── */
.sortable-handle {
  cursor: grab;
}
.sortable-handle:active {
  cursor: grabbing;
}
.dvir-items-table >>> td textarea {
  min-width: 220px;
  /* Height is driven by the v-autogrow directive; this is the floor it starts at. */
  min-height: 40px;
  overflow-y: hidden;
  resize: none;
}
/* Beats the global `.table td { vertical-align: middle !important }` — that rule
   also out-specifies the `.align-top` utility, so both need overriding here. */
.dvir-items-table >>> td {
  vertical-align: top !important;
}
/* ...except the drag handle and the delete icon, centred against the whole row. */
.dvir-items-table >>> td:first-child,
.dvir-items-table >>> td:last-child {
  vertical-align: middle !important;
}
/* Divider before each column heading from Description on (skips the drag handle
   and Title) — inset so it doesn't run the full cell height. */
.dvir-items-table >>> th:nth-child(n + 3) {
  position: relative;
}
.dvir-items-table >>> th:nth-child(n + 3)::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 1px;
  background-color: #e3e3e3;
}
</style>
